// PreCog : la console et le module du dossier (V4Precog), et les 4R d'une
// écoute (quatre-r.helper).
export default {
  sousTitre: {
    console: "Une question posée au terrain, suivie jour après jour. Les éclaireurs répondent depuis le champ vivant de leur territoire et de ce qu'ils viennent d'aller lire - ce qui se lit d'abord, c'est le mouvement, pas le niveau.",
    sansDossier: 'Le PreCog d’un dossier : choisissez-en un dans la barre de gauche.',
    dossier: '{dossier} · les questions posées au terrain de ses territoires, et les études que l’agenda de ses verticales lance de lui-même - ce qui se lit d’abord, c’est le mouvement, pas le niveau.',
    dossierAnonyme: 'Le dossier',
    dossierNomme: 'Dossier {nom}',
  },
  erreur: {
    chargement: 'Chargement impossible',
    question: 'Question illisible',
    creation: 'Création impossible',
    changement: 'Changement impossible',
    archivage: 'Archivage impossible',
    lancement: 'Lancement impossible',
    redaction: 'Redaction impossible',
    enregistrement: 'Enregistrement impossible',
    envoi: 'Envoi impossible',
    stimulus: 'Stimulus refusé',
    ancrage: 'Ancrage impossible',
  },
  territoireSansNom: 'Territoire sans nom',
  agenda: {
    badge: 'agenda',
    titre: 'Étude lancée d’elle-même par l’agenda : elle mesure le pronostic d’un événement à venir. Elle n’appartient pas au dossier, elle couvre l’une de ses verticales.',
    titreDe: 'Étude lancée d’elle-même par l’agenda de {verticale} : elle mesure le pronostic d’un événement à venir. Elle n’appartient pas au dossier, elle couvre l’une de ses verticales.',
  },
  briefing: {
    discovery: 'Idée relevée par Discovery',
    station: 'Sujet relevé par la station',
    avecEcheance: '{origine} : « {sujet} » - échéance le {echeance}.',
    sansEcheance: '{origine} : « {sujet} ».',
  },
  confirmation: {
    armer: "Armer « {question} » ?\n\n{sorties} sorties sur {jours} jour(s), soit environ {total} {'$'}.",
    armerEstime: "Armer « {question} » ?\n\n{sorties} sorties sur {jours} jour(s), soit environ {total} {'$'} (estimation).",
    lancer: "Lancer une journée pour « {question} » ?\n\n{sorties} sorties, environ {total} {'$'}.",
  },
  statut: {
    draft: 'brouillon',
    active: 'en cours',
    done: 'terminée',
    stopped: 'arrêtée',
  },
  fermer: 'fermer',
  chargement: 'chargement…',
  nouvelleQuestion: 'Nouvelle question',
  indiceCreer: 'Créer une question - elle reste en brouillon tant qu’elle n’est pas armée',
  sansDossier: "PreCog se lit par dossier : choisissez-en un dans la barre de gauche. Ses questions y interrogent les territoires qu'il suit, et l'agenda de ses verticales y dépose les études qu'il lance de lui-même.",
  formulaire: {
    exempleQuestion: 'Qui va gagner la présidentielle 2027 ?',
    exempleBriefing: 'Contexte donné aux éclaireurs - ce qu’il faut savoir pour que la question soit comprise pareil par tous, tous les jours.',
    modePanel: 'Réponses proposées',
    modeLibre: 'Insights libres',
    aidePanel: 'vous saisissez les réponses possibles - elles ne bougent plus',
    aideLibre: 'le jour 1 détermine les indicateurs, puis ils sont GELÉS : les jours suivants ne peuvent que les actualiser',
    ajouterReponse: '+ ajouter une réponse',
    auMoinsDeux: 'Au moins deux réponses - sinon il n’y a rien à départager.',
    territoiresInterroges: 'Territoires interrogés · {n}',
    ceuxDuDossier: "· ceux du dossier, cochés d'avance",
    dossierSansTerritoire: "Ce dossier ne suit encore aucun territoire : ouvrez-en un depuis sa fiche, ou rattachez-en un à l'une de ses marques.",
    eclaireursParTerritoire: 'éclaireurs / territoire',
    uneSeuleJournee: 'une seule journée',
    jusquAu: 'jusqu’au',
    sorties: 'sorties',
    rythme: '({parJour}/jour × {jours} jour(s))',
    estimation: 'estimation - aucune journée mesurée',
    creation: 'création…',
    creerBrouillon: 'Créer en brouillon',
    rienNePart: 'Rien ne part tant que la question n’est pas armée.',
  },
  liste: {
    duDossierOuvert: "Les questions du dossier {nom}, et les études que l'agenda de ses verticales a lancées d'elles-mêmes (marquées « agenda »).",
    duDossier: 'Les questions du dossier {nom}.',
    ouvert: 'ouvert',
    orion: 'Les questions d’Orion - le banc et la R&D. Ouvrez un dossier pour voir les siennes.',
    retourQuestions: 'Retour aux questions',
    archives: 'Archives ({n})',
    noteArchives: 'Les questions archivées gardent leur série, leurs réponses et leurs liens (le banc les renote, l’agenda ne les relance pas). Elles ne tournent plus ; ressortez-en une pour l’armer.',
    aucuneArchivee: 'Aucune question aux archives.',
    aucuneDossierOuvert: 'Aucune question dans le dossier {nom}, et l’agenda de ses verticales n’a encore lancé aucune étude. PreCog interroge le champ vivant des territoires - ce que les éclaireurs y voient en ce moment - et non une base figée.',
    aucuneDossier: 'Aucune question dans le dossier {nom}. PreCog interroge le champ vivant des territoires - ce que les éclaireurs y voient en ce moment - et non une base figée.',
    aucune: 'Aucune question. PreCog interroge le champ vivant des territoires - ce que les éclaireurs y voient en ce moment - et non une base figée.',
    portee: '{n} territoire(s) · {s}/terr.',
    uneJournee: 'une journée',
    jusquAuDate: 'jusqu’au {date}',
    projete: "projeté {total} {'$'}",
    ressortir: 'ressortir',
    indiceRessortir: 'Ressortir des archives - elle revient dans la liste, sans repartir',
    armer: 'armer',
    indiceArmer: 'Armer - la flotte part et la dépense commence',
    arreter: 'arrêter',
    indiceArreter: 'Arrêter - plus aucune journée ne partira',
    indiceLancer: 'Lancer une journée maintenant - c’est facturé',
    indiceArchiver: 'Archiver - elle garde sa série et quitte la liste',
  },
  protocole: {
    titre: 'Protocole',
    gele: 'gelé',
    indiceRediger: 'Un appel modèle, sans flotte - quelques centimes. Vous verrez les indicateurs AVANT de payer la première journée.',
    redaction: 'rédaction…',
    refaireRediger: 'refaire rédiger',
    faireRediger: 'faire rédiger',
    aucunLibre: 'Aucun protocole. Il fixe la question telle qu’elle est posée à l’individu, les définitions qui ne doivent pas dériver, et les indicateurs que la série suivra.',
    aucunPanel: 'Aucun protocole. Il fixe la question telle qu’elle est posée à l’individu, les définitions qui ne doivent pas dériver, et l’abstention.',
    exige: 'Il est exigé pour armer.',
    questionPosee: 'Question posée à l’individu',
    aideQuestion: '« Qui va gagner ? » demande un pronostic, « pour qui voteriez-vous ? » une intention - ce ne sont pas les mêmes mesures.',
    definitions: 'Définitions figées',
    terme: 'terme',
    sens: 'ce qu’il veut dire, et rien d’autre',
    definirTerme: '+ définir un terme',
    moteurs: "Moteurs · {theme} · ≈ {cout} {'$'} la flotte de 300",
    avecTheme: 'thème {theme}',
    sansTheme: 'sans thème',
    moteurHistorique: 'Anthropic (moteur historique, avec recherche web)',
    anterieurAuBanc: 'Protocole antérieur au banc du 22 septembre 2026 : refaire rédiger pour obtenir la paire du thème.',
    abstention: 'Abstention proposée',
    exempleAbstention: 'Ne se prononce pas - vide = aucune abstention offerte',
    aideAbstention: 'Sans elle, chaque éclaireur DOIT choisir - ce qui concentre la distribution plus qu’elle ne l’est en réalité.',
    indicateursSuivis: 'Indicateurs suivis · {n}',
    aideIndicateurs: 'Gelés au lancement : les jours suivants ne pourront que les actualiser, jamais en ajouter.',
    complet: 'Protocole complet - la question peut être armée.',
    indiceValider: 'Valider ce protocole - il sera gelé au moment d’armer',
    enregistrement: 'enregistrement…',
    valider: 'Valider le protocole',
  },
  theme: {
    securite: 'sécurité',
    identite: 'identité et laïcité',
    economie: 'économie et pouvoir d’achat',
    societe: 'société et institutions',
    croyance: 'croyance sur l’état du monde',
    autre: 'autre',
  },
  stimulus: {
    titre: 'Ce qu’on montre',
    indiceAttacher: 'Attacher une affiche, une bande-annonce ou un slogan - la flotte le regarde avant de répondre',
    attacher: 'attacher',
    rienDeMontre: 'Rien de montré : les éclaireurs répondent sur l’énoncé seul, comme au téléphone. Une affiche, une bande-annonce ou un slogan change la question posée - et c’est souvent celle-là qu’on veut mesurer.',
    genre: {
      image: 'image',
      video: 'video',
      texte: 'texte',
    },
    indiceDeposer: 'Dépose l’image ou la vidéo que les jumeaux verront',
    envoi: 'envoi…',
    choisirFichier: 'choisir un fichier',
    ouAdresse: 'ou collez une adresse - une bande-annonce pas encore sortie n’en a pas.',
    adresseVideo: 'https://… (YouTube ou fichier vidéo)',
    adresseImage: 'https://… (l’affiche, le visuel)',
    exempleTexte: 'Le texte montré tel quel : un slogan, une promesse, un titre.',
    exempleTitre: 'Ce que c’est, pour vous - le panéliste ne le lit jamais',
    moteurDecrit: 'Le moteur DÉCRIT ce qu’on montre - ce qu’on voit, ce qu’on entend, ce qui est écrit - sans dire si c’est réussi. Le jugement appartient aux éclaireurs : un modèle qui juge à leur place donne son avis à cent panélistes d’un coup.',
    enregistrement: 'enregistrement…',
    enregistrer: 'Enregistrer',
    retirer: 'retirer',
    texteManque: 'Le texte montré manque.',
    adresseManque: 'L’adresse manque, ou n’est pas en http(s).',
  },
  serie: {
    aucuneBrouillon: 'Aucune journée encore. La question est en brouillon - armez-la ou lancez une journée à la main.',
    aucuneAttente: 'Aucune journée encore. La première flotte n’est pas encore rentrée.',
    bouge: 'Ce qui bouge · {jour}',
    niveauIndicatif: 'niveau indicatif - les jumeaux reproduisent mal les niveaux, bien les variations',
    dispersion: 'Dispersion',
    dispersionVide: 'aucune réponse exploitable ce jour-là - rien à disperser',
    dispersionNulle: 'quasi nulle - sur une question clivante c’est un CONSENSUS artificiel entre jumeaux, pas une unanimité',
    dispersionReelle: 'les éclaireurs ne disent pas tous la même chose',
    deplaces: 'Déplacés par la recherche',
    deplacesAucun: 'aucun - la sortie n’a rien apporté, la série ne mesure que ce que le modèle savait déjà',
    deplacesPart: 'part des éclaireurs dont la recherche a changé la réponse',
    eclaireurs: 'Éclaireurs',
    journees: '{n} journée(s) dans la série',
    indicateursGeles: 'Indicateurs gelés au jour 1',
    ecartInterquartile: 'écart interquartile - la dispersion réelle',
    mediane: 'Médiane, pas moyenne : une valeur aberrante isolée est neutralisée, mais suivie dès que plusieurs éclaireurs la confirment.',
  },
  ancrage: {
    titre: 'Écart aux mesures réelles',
    indice: 'Enregistrer un sondage publié ou un comptage réel - il ne corrige rien, il montre l’écart',
    ajouter: '+ ajouter une mesure',
    exempleSource: 'source (Ifop 12/10, préfecture…)',
    enregistrer: 'enregistrer',
    aucun: 'Aucune mesure réelle enregistrée. Sans elle, on ne sait pas de combien l’instrument se trompe.',
  },
  bord: {
    titre: 'Selon la proximité politique',
    personne: 'personne de ce bord n’a répondu',
    reponses: '{n} réponse | {n} réponses',
    part: '{famille} - {option} : {pct} % ({n} sur {total})',
    horsFamilles: '{n} hors des quatre familles (bloc « autre »)',
    sansBord: '{n} sans bord - le territoire n’a pas d’ancrage électoral',
    seuil: 'Pour que chaque famille porte un pourcentage, il faut assez d’éclaireurs dans la plus petite - c’est elle qui commande la dépense, pas la moyenne.',
  },
  famille: {
    gauche: 'gauche',
    majorite: 'majorité présidentielle',
    droite: 'droite',
    rn: 'RN + Reconquête',
  },
  derive: {
    titre: 'Dérive politique - l’intention à l’instant T',
    ampleur: 'ampleur {ampleur} pts · n={n}',
    ancrage: 'Ancrage : {scrutin}',
    nonMesurable: 'Sur {n} éclaireur(s) de ce bloc, la dérive n’est pas mesurable.',
  },
  bloc: {
    gaucheRadicale: 'gauche radicale',
    gauche: 'gauche',
    centre: 'centre',
    droite: 'droite',
    droiteRadicale: 'droite radicale',
    autre: 'autre',
  },
  demo: {
    titre: 'Qui a répondu - âge, genre, CSP, segments',
    lecture: 'lecture du corpus…',
    toutLaSerie: 'Sur toute la série',
    stabilite: 'Stabilité de l’échantillon',
    stabiliteAide: '- âge médian et effectif, jour par jour',
    reponses: '{n} réponse(s)',
    age: '{age} ans',
  },
  corpus: {
    titre: 'Corpus - ce que chaque éclaireur a répondu',
    avant: 'avant : {option}',
    affichees: '{n} sur {total} affichées.',
  },
  // Les 4R d'une écoute : leurs noms restent ceux d'origine, leur sens se traduit.
  quatreR: {
    reach: 'Combien de personnes différentes en parlent, et sur combien de plateformes.',
    resonance: 'Le ton de ce qui s’en dit : plus il est positif, plus le score monte.',
    retention: 'Ceux qui reviennent en parler, message après message : la fidélité.',
    relevance: 'La trajectoire : le score monte-t-il ou baisse-t-il d’une période à l’autre.',
  },
}
